import { LiliTransaction } from '../types/lili-transaction';
import { TransactionStatus } from '../enum/transaction-status';
import { TransactionCheckStatus } from '../enum/transaction-check-status';

// Date format options
const options: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
};

export function transactionStatusOnTransactionsTable(t: LiliTransaction): string | null {
  if (t.transactionStatus !== TransactionStatus.PENDING) {
    return null;
  }

  if (t.checkDetailsData?.status != null) {
    switch (t.checkDetailsData.status) {
      case TransactionCheckStatus.SEND:
      case TransactionCheckStatus.ACCEPT:

        return 'In Review';

      case TransactionCheckStatus.APPROVED:
        return 'In Process';

      case TransactionCheckStatus.REJECT:
        return 'Rejected';

      default:
        return 'Pending';
    }
  } else {
    return 'Pending';
  }
}

export function transactionETA(t: LiliTransaction): string | null {
  if (t.transactionStatus !== TransactionStatus.PENDING) {
    return null;
  }

  if (t.checkDetailsData?.status != null) {
    switch (t.checkDetailsData.status) {
      case TransactionCheckStatus.SEND:
      case TransactionCheckStatus.ACCEPT:
      case TransactionCheckStatus.APPROVED:
        return null;

      default:
        if (t.checkDetailsData?.estimatedArrivalDate) {
          const formattedDate = new Date(t.checkDetailsData.estimatedArrivalDate).toLocaleDateString('en-US', options);
          return `ETA: ${formattedDate}`;
        }
        return null;
    }
  } else {
    if (t.expectedClearDate != null) {
      const formattedDate = new Date(t.expectedClearDate).toLocaleDateString('en-US', options);
      return `ETA: ${formattedDate}`;
    }
    return null;
  }
}
